appSocial.service('SocialFeedService', [
    'SocialAPIService', 'SocialUserService', 'SocialUtils', 'Trader',
    function (SocialAPIService, SocialUserService, SocialUtils, Trader) {
        class SocialFeedService {
            constructor() {
                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;
                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;
            }

            get(filter) {
                const query = this.createQuery(filter);
                return this.api.request.getFeed(query)
                    .then((response) => response.traders.map(item => new Trader(item)))
            }

            createQuery(filter) {
                return SocialUtils.createQuery(filter);
            }
        }

        return new SocialFeedService()
    }]);
